import { UploadOutlined } from '@ant-design/icons'
import { Button, Modal, ConsoleCard, CardsCol, CardsRow } from 'admin-web-ui'
import React, { useCallback, useEffect, useState } from 'react'
import { useAsyncFn } from 'react-use'
import { useProjectContext } from '../../../containers/Project'
import { DeviceCheckKeyMetaData } from './DeviceCheckKeyMetaData'
import { retrieveDeviceCheckKeyMetaData as queryData } from './retrieve-device-check-key-meta-data'
import { UploadDeviceCheckKeyDescription } from './UploadDeviceCheckKeyDescription'
import { UploadDeviceCheckKeyForm } from './UploadDeviceCheckKeyForm'

type ModalState = 'open' | 'closed'

export const UploadDeviceCheckKey: React.FC = () => {
  const { projectClient } = useProjectContext()
  const [modalState, setModalState] = useState<ModalState>('closed')

  const [deviceCheckKeyResult, getDeviceCheckKeyMetaData] = useAsyncFn(
    () => queryData(projectClient),
    [projectClient],
  )

  useEffect(() => {
    getDeviceCheckKeyMetaData()
  }, [getDeviceCheckKeyMetaData])

  const modalSuccessHandler = useCallback(() => {
    setModalState('closed')
    getDeviceCheckKeyMetaData()
  }, [getDeviceCheckKeyMetaData])

  const modalCancelHandler = useCallback(() => {
    setModalState('closed')
  }, [])

  return (
    <CardsRow>
      <CardsCol span={24}>
        <ConsoleCard
          title="iOS DeviceCheck Key"
          loading={deviceCheckKeyResult.loading}
          extra={
            <Button
              id="client-config__download-button"
              type="default"
              shape="round"
              icon={<UploadOutlined />}
              onClick={() => setModalState('open')}
            >
              {deviceCheckKeyResult.value ? 'Replace Key' : 'Upload Key'}
            </Button>
          }
        >
          {deviceCheckKeyResult.value && (
            <DeviceCheckKeyMetaData metaData={deviceCheckKeyResult.value} />
          )}
          <UploadDeviceCheckKeyDescription />
        </ConsoleCard>
      </CardsCol>
      <Modal
        title="Upload iOS DeviceCheck Key"
        open={modalState === 'open'}
        onCancel={modalCancelHandler}
        footer={null}
      >
        {/* Ensure form remounts each time modal opens */}
        {modalState === 'open' && (
          <UploadDeviceCheckKeyForm
            projectClient={projectClient}
            onSuccess={modalSuccessHandler}
            onCancel={modalCancelHandler}
          />
        )}
      </Modal>
    </CardsRow>
  )
}
